import { createContext, useContext, useState, useCallback } from "react";

const TZ_KEY = "userTimezone";
const DEFAULT_TZ = "America/New_York";

const TimezoneContext = createContext(DEFAULT_TZ);
const TimezoneUpdaterContext = createContext(() => {});

export function TimezoneProvider({ children }) {
  const [timezone, setTimezone] = useState(
    () => localStorage.getItem(TZ_KEY) || DEFAULT_TZ
  );

  const updateTimezone = useCallback((tz) => {
    const value = tz || DEFAULT_TZ;
    localStorage.setItem(TZ_KEY, value);
    setTimezone(value);
  }, []);

  return (
    <TimezoneContext.Provider value={timezone}>
      <TimezoneUpdaterContext.Provider value={updateTimezone}>
        {children}
      </TimezoneUpdaterContext.Provider>
    </TimezoneContext.Provider>
  );
}

export function useTimezone() {
  return useContext(TimezoneContext);
}

export function useUpdateTimezone() {
  return useContext(TimezoneUpdaterContext);
}
